import { render, staticRenderFns } from "./SyncFromSO.vue?vue&type=template&id=dd3a79a4"
import script from "./SyncFromSO.vue?vue&type=script&lang=js"
export * from "./SyncFromSO.vue?vue&type=script&lang=js"
import style0 from "./SyncFromSO.vue?vue&type=style&index=0&id=dd3a79a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports